import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { useI18N } from '../../context/I18NContext';
import useWidgetStore from '../../store/useWidgetStore';
export default function SubscriptionList(props) {
    const { subscriptions } = props;
    const { t, ts } = useI18N();
    const theme = useTheme();
    const { language } = useWidgetStore();
    const date = (value) => dayjs(value).locale(language).format('D MMMM YYYY');
    /** What is left on it: a number of credits, or no number at all when it has no limit. */
    const balance = (subscription) => subscription.infiniteCredits
        ? t('Onbeperkt')
        : ts('%balance% van %value% strippen', {
            balance: subscription.balance,
            value: subscription.value
        });
    /**
     * How long it is good for: the dates while it can still be used, the reasons once it cannot.
     * Both come from the API, which applies the company's rules; this only puts them in words.
     */
    const validity = (subscription) => {
        if (!subscription.valid) {
            return subscription.expiredReasons;
        }
        const lines = [
            subscription.startDate
                ? ts('Geldig vanaf %date%', { date: date(subscription.startDate) })
                : subscription.endDate
                    ? ts('Geldig tot %date%', { date: date(subscription.endDate) })
                    : t('Geen vervaldatum')
        ];
        if (subscription.bookingStartDate) {
            lines.push(ts('Te gebruiken vanaf %date%', { date: date(subscription.bookingStartDate) }));
        }
        return lines;
    };
    if (!subscriptions.length) {
        return (_jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary }, children: t('Je hebt geen strippenkaarten of abonnementen.') }));
    }
    return (_jsx(TableContainer, { component: Paper, sx: {
            backgroundColor: theme.palette.background.default
        }, children: _jsx(Table, { sx: {
                width: '100%',
                marginBottom: 2,
            }, "aria-label": "simple table", children: _jsx(TableBody, { children: subscriptions.map((subscription) => (_jsxs(TableRow, { sx: { '&:last-child td, &:last-child th': { border: 0 } }, children: [_jsxs(TableCell, { component: "th", scope: "row", sx: { verticalAlign: 'top' }, children: [subscription.title, _jsx("br", {}), _jsx(Typography, { component: "span", variant: "body2", children: subscription.typeLabel }), validity(subscription).map((line, index) => (_jsx(Typography, { variant: "body2", 
                                    // a subscription that can no longer be used says so in the
                                    // colour the widget uses for everything else that is wrong
                                    color: subscription.valid ? 'inherit' : 'error', children: line }, index)))] }), _jsx(TableCell, { align: "right", sx: { verticalAlign: 'top' }, children: balance(subscription) })] }, subscription.id))) }) }) }));
}
